/* The Flaire — instalment messaging controller (Sep 2026).
 *
 * 1. WHY AN AFTERPAY FALLBACK EXISTS
 * Afterpay IS a live payment method at this store's checkout (verified in the
 * checkout payload: OffsiteProvider "Afterpay", brand cashappafterpay,
 * presentment currency USD; 157 Afterpay orders since 20 Jun 2026). But
 * Afterpay's own on-site messaging widget renders NOTHING: square-marketplace.js
 * throws "Square.Marketplace.CBTLimitsConfigMissingError: CBT limit
 * configurations not found" on every product page, with the market forced to US
 * as well as AU — the merchant account has no cross-border-trade limits set for
 * the presentment currency. Only Afterpay merchant support can fix that.
 * This file draws Afterpay's standard lockup in the exact spot their widget
 * would occupy, and removes itself the moment their widget starts working.
 *
 * 2. ONE INSTALMENT MESSAGE PER SHOPPER (Mehar's rule, 18 Sep 2026)
 * Evidence, last 250 orders (31 Aug – 18 Sep 2026):
 *   AU 117 orders → 27 paid with Afterpay (23.1%)
 *   CA  27 orders →  6 Afterpay (22.2%)   NZ 1 → 1
 *   US  76 orders →  4 Afterpay (5.3%)    GB 27 → 0
 * Shopify only renders its own Shop Pay instalments element
 * (shopify-payment-terms) for the US market — it is absent entirely on AU.
 * RULE: US → Shop Pay only (our line is removed). Everyone else → Afterpay
 * only (any Shop Pay terms element is hidden). Country unknown → defer to
 * Shopify: if its element is showing, we stay out of the way. The two
 * messages can never appear together.
 */
(function () {
  'use strict';
  var BADGE = window.FLAIRE_AFTERPAY_BADGE || '';
  var INFO = 'https://www.afterpay.com/en-US/how-it-works';
  var pending = null;

  function injectCss() {
    if (document.getElementById('fr-ap-style')) return;
    var s = document.createElement('style');
    s.id = 'fr-ap-style';
    s.textContent =
      '.fr-ap{display:flex;align-items:center;flex-wrap:wrap;gap:.5rem;margin:1.2rem 0 0;font-size:1.4rem;line-height:1.5;letter-spacing:.01em}' +
      '.fr-ap b{font-weight:600}' +
      '.fr-ap img{display:inline-block;height:3rem;width:auto;vertical-align:middle;border-radius:.4rem}' +
      '.fr-ap a{display:inline-flex;align-items:center;justify-content:center;width:1.7rem;height:1.7rem;border:1px solid currentColor;border-radius:50%;font-size:1.1rem;line-height:1;text-decoration:none;color:inherit;opacity:.7}' +
      '.fr-ap a:hover{opacity:1}' +
      '@media screen and (max-width:749px){.fr-ap{font-size:1.3rem}.fr-ap img{height:2.8rem}}';
    document.head.appendChild(s);
  }

  function money(amount, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: currency || 'USD', currencyDisplay: 'narrowSymbol'
      }).format(amount);
    } catch (e) { return '$' + amount.toFixed(2); }
  }

  function shopperCountry() {
    var c = (window.Shopify && Shopify.country) || '';
    if (!c) {
      var f = document.querySelector('form[action*="/localization"] input[name="country_code"]');
      c = (f && f.value) || '';
    }
    return String(c).toUpperCase();
  }
  function shopPayTerms() { return document.querySelectorAll('shopify-payment-terms'); }
  function shopPayShowing() {
    var out = false;
    shopPayTerms().forEach(function (t) { if (t.getBoundingClientRect().height > 0) out = true; });
    return out;
  }
  function afterpayIsTheOne() {
    var c = shopperCountry();
    if (c === 'US') return false;
    if (c) return true;
    return !shopPayShowing();
  }
  function setShopPayHidden(hide) {
    shopPayTerms().forEach(function (t) {
      if (hide) { t.dataset.frHidden = '1'; t.style.display = 'none'; }
      else if (t.dataset.frHidden) { delete t.dataset.frHidden; t.style.display = ''; }
    });
  }

  function render() {
    injectCss();
    var mine = afterpayIsTheOne();
    setShopPayHidden(mine);
    window.FLAIRE_AFTERPAY_MARKET = mine; /* the cart drawer reads this */

    document.querySelectorAll('square-placement').forEach(function (sp) {
      var line = sp.parentElement && sp.parentElement.querySelector('.fr-ap');
      var widgetShowing = sp.getBoundingClientRect().height > 0;
      var amount = parseFloat(sp.getAttribute('data-amount'));

      /* Not our market, no price, or Afterpay's real widget is drawing — stand down. */
      if (!mine || widgetShowing || !(amount > 0)) { if (line) line.remove(); return; }

      var part = Math.round(amount / 4 * 100) / 100;
      var html = 'or 4 interest-free payments of <b>' + money(part, sp.getAttribute('data-currency')) + '</b> with' +
        (BADGE ? ' <img src="' + BADGE + '" alt="Afterpay" width="80" height="50">' : ' <b>Afterpay</b>') +
        ' <a href="' + INFO + '" target="_blank" rel="noopener nofollow" aria-label="Learn more about Afterpay">i</a>';

      if (!line) {
        line = document.createElement('p');
        line.className = 'fr-ap';
        sp.insertAdjacentElement('afterend', line);
      }
      if (line.innerHTML !== html) line.innerHTML = html;

      if (!sp.__frAp) {
        sp.__frAp = true;
        new MutationObserver(schedule).observe(sp, { attributes: true, attributeFilter: ['data-amount', 'data-currency'] });
      }
    });
  }

  function schedule() { clearTimeout(pending); pending = setTimeout(render, 150); }

  function start() { render(); setTimeout(render, 2500); setTimeout(render, 6000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  /* variant switches change the price → re-render */
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('variant-selects, variant-radios, product-form, .product-form__input')) schedule();
  });
})();
